import { Component, OnInit, ViewChild, AfterViewInit, AfterViewChecked } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { ContractService } from '../../services/contract.service';
import { Router } from '@angular/router';
import { ModalComponent } from '../../shared-components/modal/modal.component';
import { AdminService } from '../../services/Admin.service';
import { userProfile } from '../../models/userProfile';
import { DataService } from './../../services/data.service';
import { Title } from '@angular/platform-browser';
import { TransientTypes } from '../../models/TransientTypes';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit, AfterViewInit {
  public liveAgentId = '57360000000Kyxu';
  currentTransientType: TransientTypes = TransientTypes.cdd;
  @ViewChild('popup') popup: ModalComponent;
  public env = 'Test';
  public quoteUrl = '';
  public jetSupportUrl = '';
  public isAnnualMeeting = false;
  public currentDate = new Date();
  public user: userProfile;
  public userInfo: any;
  public name = '';
  public header: string;
  loading = false;
  externalUrl: string;
  currentTransientUrl: string;

  @ViewChild('chatOffline') modal1: ModalComponent;
  constructor(private _authService: AuthService,
    private _router: Router,
    private adminSVC: AdminService,
    private contractSvc: ContractService,
    private dataSvc: DataService,
    private titleSvc: Title
  ) {
    if (dataSvc.userDisplayInfo) {

      this.name = dataSvc.userDisplayInfo.FirstName + ' ' + dataSvc.userDisplayInfo.LastName;
    }
    console.log(this.name + ' Name');
    titleSvc.setTitle('MyJSSI Client');
  }

  ngOnInit() {
    this.userInfo = this.dataSvc.userDisplayInfo;
    this.name = this.userInfo.FirstName + ' ' + this.userInfo.LastName;
    this.contractSvc.updateHeader('Client');
    this.header = this.contractSvc.header;
    console.log(this.name + 'Name');
    console.log(this.userInfo.FirstName + ' Info');

    this.currentDate = new Date(this.currentDate.getUTCFullYear(), this.currentDate.getUTCMonth(), this.currentDate.getUTCDate(),
      this.currentDate.getUTCHours(), this.currentDate.getUTCMinutes(), this.currentDate.getUTCSeconds());
  }

  async ngAfterViewInit() {
    const keyValue = await this.contractSvc.getConfig('IsAnnualMeeting');
    if (keyValue === 'True') {
      this.isAnnualMeeting = true;
    }
    this.liveAgentId = await this.contractSvc.getConfig('LiveAgentId');
    this.env = await this.contractSvc.getConfig('Env');
    this.jetSupportUrl = await this.contractSvc.getConfig('JetsupportUrl');
    this.quoteUrl = this.jetSupportUrl + '#quote';
    await this.initializeLiveChartScript();
  }

  redirectToChatOffline() {
    this._router.navigate([`/pages/client/my-contracts/contract/live-chat`]);
  }

  private initializeLiveChartScript() {
    return new Promise((resolve, reject) => {
      if (document.getElementById('scrChat')) {
        document.getElementById('scrChat').remove();
      }

      if (document.getElementById('scrChatMyJSSI')) {
        document.getElementById('scrChatMyJSSI').remove();
      }
      const scriptTag = document.createElement('script');
      scriptTag.id = 'scrChatMyJSSI';
      scriptTag.type = 'text/javascript';
      scriptTag.innerHTML = 'initChat("' + this.env + '")';
      document.body.appendChild(scriptTag);
    });
  }

  IsADUser() {
    return this.dataSvc.userDisplayInfo.UserTypeID === 5;
  }

  logOut() {
    this._authService.logOut();

    // if (this.jetSupportUrl === 'https://jetsupport.com/') {
    //   this._router.navigate(['/pages/login']);
    // } else {
  ////  window.open(this.jetSupportUrl + 'log-in', '_self');
    // }

  }


  onSwitchButtonClick(destinationAppId: string) {
    console.log('inside swtich button');

    this.loading = false;

    this.currentTransientType = TransientTypes.cdd;
    this.loading = false;
    if (!this.loading) {
      this.loading = true;


      this._authService.getTransientUrl(this.dataSvc.userDisplayInfo.id, destinationAppId,
        this.dataSvc.userDisplayInfo.bearerToken)
        .subscribe(
          url => {

            console.log('URL', url);
            this.externalUrl = url;
            this.currentTransientUrl = url;
            const urlSplits = url.split('?');
            if (urlSplits.length > 1) {
              const paramString = urlSplits[1];
              const queryString = new URLSearchParams(paramString);
              const authToken = queryString.get('token');
              if (authToken == null) {
                location.href = url;
              }
              const firstTimeLoggingIn = authToken.split('^')[1];
              if (firstTimeLoggingIn === '1') {
                this.popup.show();

              } else {

                this._authService.logOut();
                location.href = url;

                // console.log(url);

              }
            } else {

              this._authService.logOut();
              location.href = url;

              // console.log(url);

            }
          }

        );
    }

    return false;
  }
  navigateToOtherSite(url: string) {
    this._authService.logOut();
    location.href = this.externalUrl;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/client/client.component.ts